import React from 'react';
import { SourceEntity } from "../../sourcePicker/SourceEntity";
import { Form } from 'react-bootstrap';

/**Temp source list */
export const SourceListV2 = (props) => {
    // const 
    //if its supposed to show sources create a map of any sources on file
    if (props.sourceShow) {
        var folderMap = () => {
            if (props.sources !== undefined) {
                const map = props.sources.map((source) => {
                    return <SourceEntity {...source} key={source.id} onSourceSetter={props.onRemoveSource} />;
                });
                return <ul>{map}</ul>;
            }
            return null;
        };
    }
    return props.sourceShow ? <Form.Group>
        <p className="text-center">Click on a data source to remove</p>
        <div className="sourceList">
            {folderMap()}
        </div>
    </Form.Group> : null;
};



// WEBPACK FOOTER //
// ./src/components/tree/node/SourceListV2.js